import { alpha, Theme } from '@mui/material/styles';
import { typography } from '@shared/theme/typography';
import { MobileTheme } from './types';

// eslint-disable-next-line max-lines-per-function
export const buildOverrides = (theme: MobileTheme) => {
  const { palette, spacing, breakpoints } = theme;
  const overrides: Theme['components'] = {
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 42,
          height: 42,
        },
        colorDefault: {
          backgroundColor: palette.primary[600],
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(palette.neutrals[900], 0.85),
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: 'transparent',
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          width: '100%',
        },
        html: {
          display: 'flex',
          minHeight: '100%',
          overflow: 'hidden auto',
          overscrollBehaviorY: 'none',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderBottomWidth: '1px',
          borderColor: palette.neutrals[300],
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '&:first-of-type': {
            marginTop: 0,
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          lineHeight: '1.45',
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          fontSize: 19,
          fontWeight: 700,
          color: palette.text.primary,
          padding: '0 15px',
          textAlign: 'left',
          lineHeight: '25px',
          borderBottom: `1px solid ${palette.divider}`,
        },
        gutters: {
          [breakpoints.up('sm')]: {
            padding: '10px 15px',
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginBottom: 0,
          marginTop: 0,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          userSelect: 'initial',
        },
        gutters: {
          padding: '15px 10px',
          paddingLeft: 10,
          paddingRight: 10,
          [breakpoints.up('sm')]: {
            padding: '15px 10px',
            paddingLeft: 10,
            paddingRight: 10,
          },
        },
        divider: {
          borderBottom: `2px solid ${palette.divider}`,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: palette.neutrals[300],
          },
        },
        focusVisible: {
          backgroundColor: 'rgba(230, 236, 240, 0.7)',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        padding: {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiListItemSecondaryAction: {
      styleOverrides: {
        root: {
          right: 4,
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          left: 0,
          right: 0,
        },
        anchorOriginTopCenter: {
          top: 0,
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 0,
        },
        indicator: {
          backgroundColor: palette.primary.main,
          height: 2,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 53,
          minWidth: 0,
          textTransform: 'none',
          fontSize: '1rem',
          [breakpoints.up('md')]: {
            minWidth: 0,
          },
        },
        fullWidth: {
          flexBasis: 'auto',
        },
        textColorInherit: {
          opacity: 1,
        },
        selected: {
          fontWeight: 700,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        gutters: {
          paddingLeft: spacing(4),
          paddingRight: spacing(4),
        },
      },
    },
    MuiTouchRipple: {
      styleOverrides: {
        child: {
          backgroundColor: '#657786',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          '& > p': {
            margin: 0,
            '& + p': {
              marginTop: '1em',
            },
          },
        },
        button: { ...typography.subtitle1 },
      },
    },
  };
  return overrides;
};
